import React from 'react'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import Userprofile from '../components/Userprofile/Userprofile'
const UserProfilePage = () => {
  return (
    <>
    <Header/>
    <Userprofile/>
    <Footer/>
    </>
  )
}

export default UserProfilePage